import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-6" }
const _hoisted_2 = { class: "col-span-4" }
const _hoisted_3 = { class: "lg:flex lg:justify-end" }
const _hoisted_4 = { class: "mt-8 lg:mt-11" }
const _hoisted_5 = {
  id: "cta-sticky",
  class: "fixed bottom-4 left-4 z-20 lg:left-1/2 lg:left-1/2 lg:w-fit lg:-translate-x-1/2"
}
const _hoisted_6 = { class: "mx-auto flex w-fit items-center" }
const _hoisted_7 = { class: "m-auto whitespace-nowrap pr-6 pl-8 font-medium" }
const _hoisted_8 = { class: "z-10 grid" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-start-1 row-start-1 h-15 w-15 scale-50 animate-expand-hide rounded-full bg-cta-blue/50" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_collapse_transition = _resolveComponent("collapse-transition")!
  const _component_biz_icon = _resolveComponent("biz-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "header")
      ]),
      (!_ctx.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open)),
            class: "col-span-2"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "open")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.hero && _ctx.dropdown)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["relative overflow-hidden transition-all duration-500", _ctx.open ? 'max-h-full' : 'max-h-32']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = true))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([[
                _ctx.open ? 'hidden bg-transparent' : 'bg-gradient-to-t pt-8',
                _ctx.color ? 'from-dark-blue via-dark-blue/40' : 'from-gray-200 via-gray-200/40'
            ], "absolute bottom-0 z-10 h-16 w-full transition-all duration-1000 lg:from-white lg:via-white/40"])
          }, null, 2),
          _renderSlot(_ctx.$slots, "default")
        ], 2))
      : (_openBlock(), _createBlock(_component_collapse_transition, { key: 1 }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "default")
            ], 512), [
              [_vShow, _ctx.open]
            ])
          ]),
          _: 3
        })),
    (_ctx.showSitckyButton && _ctx.firstStickyButton)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 2,
          to: "body"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_Transition, { name: "fade-slide-up" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.showButton && !_ctx.editMode)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollToAnchor && _ctx.scrollToAnchor(...args))),
                        class: "group relative flex justify-center overflow-visible"
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["-mr-15 hidden h-15 items-center justify-center rounded-full bg-white pr-14 shadow-[0_0_10px_0_rgba(0,0,0,0.16)] lg:flex", 
                                _ctx.startHide
                                    ? 'animate-maxwidth-shrink'
                                    : 'max-w-0 animate-maxwidth-expand-delay opacity-0'
                            ])
                        }, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.label), 1)
                        ], 2),
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("div", {
                            class: _normalizeClass(["col-start-1 row-start-1 flex h-15 w-15 items-center justify-center rounded-full border border-cta-blue bg-cta-blue group-hover:bg-white", 
                                    _ctx.startHide
                                        ? 'animate-fade-slide-down-delay'
                                        : 'animate-fade-slide-up'
                                ])
                          }, [
                            _createVNode(_component_biz_icon, {
                              name: "email",
                              class: _normalizeClass(_ctx.iconClasses)
                            }, null, 8, ["class"])
                          ], 2)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}